import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { IsNotNull, IsNotNullOrEmpty, IsNullOrEmpty } from "@apply4u/shared/helpers/common/type-safe-helpers";
import { Observable } from "rxjs";
import { Systemuser } from "../models/systemuser";
import { HttpClientWrapper } from "./httpclientwrapper";
import { LoadingService } from "./loading.service";
import { LocalstorageService } from "./localstorage.service";
import { SaveSearchServices } from "./save-searches";

import { Candidate } from "@apply4u/models/talent-messenger/candidate";
import { UserTracking } from "@apply4u/models/tracking/user-tracking";
import { ContextLevelKeys } from "@apply4u/shared/constant/Local-storage-keys/context-level-keys";
import { LoginTypeKeys } from "@apply4u/shared/constant/Local-storage-keys/login-type-keys";
import { DashBoard_RouteUrl } from "@apply4u/shared/constant/navigation/navigation";
import { DashboardType, DashboardType as DashboardTypeEnum } from "@apply4u/shared/enums/dashboard-type.enum";
import { ContextService } from "./context-service";
import { environment } from "@environment/environment";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  BaseUrl: string = this._http.BaseUrl;

  constructor(private router: Router,
    private _http: HttpClientWrapper,
    private localStorageService: LocalstorageService,
    private loadingService: LoadingService,
    private savedSearchService: SaveSearchServices,
    private contextService: ContextService) {

      // if(this.contextService.IsBrowser && this.contextService.IsUserLoggedIn){
      //   const loginEmail =  this.localStorageService.GetItem(LoginTypeKeys.LoginName);
      //  if(IsNotNullOrEmpty(loginEmail)){
      //   this.LoadUserProfile(loginEmail,false);
      //   this.contextService.SetupDefaults();
      //  }
       
      // }
  }

  GetEmailAlreadyExist(loginName: string): Observable<Systemuser[]> {
    if (loginName !== undefined && loginName != null && loginName != "") {
      loginName = encodeURIComponent(loginName);
    }

    return this._http.GetAsync<Systemuser[]>(this.BaseUrl + "api/SystemUsers/Search/EmailAlreadyExist?loginName=" + loginName);
  }

  GetSystemUserbyLoginName(loginName: string): Observable<Systemuser[]> {

    if (loginName !== undefined && loginName != null && loginName != "") {

      loginName = encodeURIComponent(loginName);
    }
    return this._http.GetAsync<Systemuser[]>(this.BaseUrl + "api/SystemUsers/search?isActive=1&loginName=" + loginName);
  }

  GetSystemUserDetailByLoginName(loginName: string): Observable<Systemuser> {
    if (loginName !== undefined && loginName != null && loginName != "") {
      loginName = encodeURIComponent(loginName);
    }
    return this._http.GetAsync<Systemuser>(this.BaseUrl + "api/SystemUsers/userdetail?loginName=" + loginName);
  }

  GetUserProfileByLoginName(loginName: string): Systemuser {
    if (IsNotNullOrEmpty(loginName)) {
      loginName = encodeURIComponent(loginName);
    }

    return this._http.GetSync<Systemuser>(`${this.BaseUrl}api/SystemUsers/userdetail?loginName=${loginName}`,false);
  }

  ValidateUserCredentials(password: string, userId: number): Observable<boolean> {

    if (IsNotNullOrEmpty(password)) {
      password = encodeURIComponent(password);
    }
    return this._http.GetAsync<boolean>(this.BaseUrl + "api/SystemUsers/validateUserCredentials?userId=" + userId + '&password=' + password);
  }

  LoadUserProfile(username: string, shouldRedirect: boolean = true): void {
     const result = this.GetUserProfileByLoginName(username);

      if (IsNotNull(result)) {
        this.contextService.LoggedInUserId = result.Id;
        this.localStorageService.SetItem(LoginTypeKeys.SystemUserObject, JSON.stringify(result));
        this.localStorageService.SetItem(LoginTypeKeys.IsPublicNotesAllowed, JSON.stringify(result.IsPublicNotesAllowed))
        this.localStorageService.SetItem(LoginTypeKeys.LoggedInUserId, result.Id.toString());
        this.localStorageService.SetItem(LoginTypeKeys.LoginName, result.LoginName);
        this.localStorageService.SetItem(LoginTypeKeys.ShortlistId,IsNotNull(result.ShortlistId)? result.ShortlistId.toString():"");
        this.localStorageService.SetItem(LoginTypeKeys.ShortlistName, IsNotNull(result.ShortlistName)? result.ShortlistName: "");
        this.localStorageService.SetItem(LoginTypeKeys.JobWishlistId, IsNotNull(result.JobWishlistId)? result.JobWishlistId.toString():"");
        this.localStorageService.SetItem(LoginTypeKeys.JobWishlistName, IsNotNull(result.JobWishlistName)? result.JobWishlistName: "");
        if (IsNotNull(result.IsAdmin) && result.IsAdmin == true) {
          this.localStorageService.SetItem(LoginTypeKeys.IsLoggedInUserSuperAdmin, "1");
        }
  
        if (IsNotNull(result.UserProfile)) {
          this.localStorageService.SetItem(LoginTypeKeys.IsLoggedInUserCompanyAdmin, JSON.stringify(result.IsCompanyAdmin))
          this.localStorageService.SetItem(LoginTypeKeys.IsCompanyMember, JSON.stringify(result.IsCompanyMember));
          this.SetSelectedUserTypesAndDashboardType(result.UserProfile, result.Id);
          this.GetUserProfileViewUrlOnLoad(result);
          if (IsNotNullOrEmpty(result.UserProfile.ProfileImagePath)) {
            this.localStorageService.SetItem(LoginTypeKeys.ProfileImagePath, result.UserProfile.ProfileImagePath.toString());
          }
  
          if (IsNotNull(result.UserProfile.CvLibraryRegistration)) {
            this.localStorageService.SetItem(LoginTypeKeys.RegisteredWithCVL, "1");
          }
  
          this.SetUserDetailInLocalStorage(result);
        }

        this.savedSearchService.ValidateUserPackage(this.contextService.LoggedInUserId).subscribe();
      }

      if (shouldRedirect) {
        const url = this.GetRedirectUrl();
        this.router.navigateByUrl(url);
        this.contextService.ClearNavigationHistory(`${environment.HostName}${url}`);
      }    
  }

  SetSelectedUserTypesAndDashboardType(UserProfile: any, userId: number) {
    this.localStorageService.RemoveItem(ContextLevelKeys.IsCandidate);
    this.localStorageService.RemoveItem(ContextLevelKeys.IsRecruiter);

    if (IsNotNull(UserProfile)) {
      if (IsNotNull(UserProfile.IsCandidate) && UserProfile.IsCandidate == true && IsNotNull(UserProfile.IsRecruiter) && UserProfile.IsRecruiter == true) {
        this.localStorageService.SetItem(ContextLevelKeys.IsRecruiter, "1");
        this.localStorageService.SetItem(ContextLevelKeys.IsCandidate, "1");

        if (IsNotNull(UserProfile.DashboardTypeId)) {
          this.contextService.SetIsJobSeeker(UserProfile.DashboardTypeId == DashboardType.JobSeeker);

        } else {
          this.contextService.SetIsJobSeeker(true);

        }
      } else if (UserProfile.IsRecruiter != null && UserProfile.IsRecruiter == true) {
        this.contextService.SetIsJobSeeker(false);

        this.localStorageService.SetItem(ContextLevelKeys.IsRecruiter, "1");

      } else if (UserProfile.IsCandidate != null && UserProfile.IsCandidate == true) {
        this.contextService.SetIsJobSeeker(true);
        this.localStorageService.SetItem(ContextLevelKeys.IsCandidate, "1");

      }
    }
  }

  Registr(registration: any): Observable<any> {
    registration.IsAdmin = false;

    return this._http.PostAsync(this.BaseUrl + "api/SystemUsers", registration);
  }

  RegisterTalentUser(candidate: Candidate): Observable<number> {
    return this._http.PostAsync(`${this._http.BaseUrl}api/affiliates/talent/newcandidate`, candidate)
  }

  SetUserDetailInLocalStorage(result: Systemuser) {

    if (result !== undefined && result != null) {
      this.localStorageService.SetItem(LoginTypeKeys.LoginName, result.LoginName.toString());

      if (result.UserProfile.FirstName !== undefined && result.UserProfile.FirstName != null && result.UserProfile.FirstName != "") {
        this.localStorageService.SetItem(LoginTypeKeys.UserFirstName, result.UserProfile.FirstName.toString());
      }

      let loggedInUserTitle;

      if ((result.UserProfile.FirstName !== undefined && result.UserProfile.FirstName != null && result.UserProfile.FirstName != "") ||
        (result.UserProfile.LastName !== undefined && result.UserProfile.LastName != null && result.UserProfile.LastName != "")) {

        loggedInUserTitle = result.UserProfile.FirstName + ' ' + result.UserProfile.LastName;
      }

      if (loggedInUserTitle !== undefined && loggedInUserTitle != null && loggedInUserTitle != "") {
        this.localStorageService.SetItem(LoginTypeKeys.LoggedInUserTitle, loggedInUserTitle);
      }
    }
  }

  GetRedirectUrl(): string {
    let redirectUrl = this.localStorageService.GetItem(LoginTypeKeys.RedirectUrl_Key);

    if (this.contextService.IsJobSeekerTypeActivated) {
      let jobApplyUrl = this.localStorageService.GetItem(LoginTypeKeys.RedirectJobApplyUrl_Key);

      if (IsNotNullOrEmpty(jobApplyUrl)) {
        redirectUrl = jobApplyUrl;
      }
    }

    this.localStorageService.RemoveItem(LoginTypeKeys.RedirectUrl_Key);
    this.localStorageService.RemoveItem(LoginTypeKeys.RedirectJobApplyUrl_Key);

    if (IsNullOrEmpty(redirectUrl)) {
      redirectUrl = DashBoard_RouteUrl;
    }

    return redirectUrl;
  }

  GenerateUsersFormattedURLParams(userprofile: Systemuser): string {
    let autocreatedurlparam: string = "";

    if (userprofile.UserProfile.FirstName !== undefined && userprofile.UserProfile.FirstName != null && userprofile.UserProfile.FirstName.trim() != "") {
      autocreatedurlparam += userprofile.UserProfile.FirstName.trim() + " ";
    }

    if (userprofile.UserProfile.LastName !== undefined && userprofile.UserProfile.LastName != null && userprofile.UserProfile.LastName.trim() != "") {
      autocreatedurlparam += userprofile.UserProfile.LastName.trim() + " ";
    }

    if (userprofile.Experiences !== undefined && userprofile.Experiences != null && userprofile.Experiences.length > 0) {
      if (userprofile.Experiences[0].JobTitle !== undefined && userprofile.Experiences[0].JobTitle != null && userprofile.Experiences[0].JobTitle.trim() != "") {
        autocreatedurlparam += userprofile.Experiences[0].JobTitle.trim() + " ";
      }
    }

    if (userprofile.Addresses !== undefined && userprofile.Addresses != null && userprofile.Addresses.length > 0) {
      if (userprofile.Addresses[0].City !== undefined && userprofile.Addresses[0].City != null && userprofile.Addresses[0].City.trim() != "") {
        autocreatedurlparam += " in " + userprofile.Addresses[0].City.trim() + " ";
      }
    }

    if (userprofile.Id !== undefined && userprofile.Id != null && userprofile.Id > 0) {
      autocreatedurlparam += userprofile.Id;
    }

    if (autocreatedurlparam !== undefined && autocreatedurlparam != null && autocreatedurlparam.trim() != "") {
      if (autocreatedurlparam.toString().includes(",")) {
        autocreatedurlparam = autocreatedurlparam.toString().trim().split(',').join(' ');
      }

      if (autocreatedurlparam.toString().includes("  ")) {
        autocreatedurlparam = autocreatedurlparam.toString().trim().split('  ').join(' ');
      }

      if (autocreatedurlparam.toString().includes(" ")) {
        autocreatedurlparam = autocreatedurlparam.toString().trim().split(' ').join('-');
      }

      autocreatedurlparam = autocreatedurlparam.replace(/[^0-9a-zA-Z-]/g, "");

      return autocreatedurlparam.toString().toLowerCase();
    }

    return;
  }

  GetUserProfileViewUrlOnLoad(SystemUserProfile: Systemuser) {
    if (IsNotNull(SystemUserProfile)) {
      let UserProfileViewUrl = this.GenerateUsersFormattedURLParams(SystemUserProfile);

      if (IsNotNull(UserProfileViewUrl)) {
        this.localStorageService.SetItem(LoginTypeKeys.LoggedInUserMyProfileRedirectedURL, UserProfileViewUrl);
      }
    }
  }

  UserTracking(userTracking: UserTracking): Observable<number> {
    return this._http.PostAsync(`${this._http.BaseUrl}api/SystemUsers/tracking`, userTracking)
  }

  UpdateLastLogin(userId: number) {
    return this._http.PutAsync(`${this.BaseUrl}api/UserProfiles/UpdateLastLogin?userId=${userId}`, null);
   }
}